import { RETRIEVE_WITH_PROJECT_ID_PENDING } from 'Constants/ProjectDetail/ProjectDetail.constants';

export function retrieveProjectDetailWithProjectId(projectId) {
  return {
    type: RETRIEVE_WITH_PROJECT_ID_PENDING,
    payload: { projectId }
  };
}
